export default function renderPercentageValue(input: any) {
  const parsed = parseFloat(input);

  return isNaN(parsed) ? 0 : (Math.round(parsed * 100) / 100)
}